/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { type Meta, type StoryObj } from '@storybook/react-vite';

import { Banner } from '../../index';
import {
  BannerCloseable,
  BannerCloseableSrc,
  BannerGlobal,
  BannerGlobalSrc,
  BannerVariants,
  BannerVariantsSrc,
  BannerWithActions,
  BannerWithActionsSrc,
  BannerWithIcons,
  BannerWithIconsSrc,
  BannerWithoutTitle,
  BannerWithoutTitleSrc,
} from '.';

const componentMeta: Meta<typeof Banner> = {
  component: Banner,
  id: 'components-banner',
  parameters: {
    controls: { disable: true },
  },
  tags: ['docsPage'],
  title: 'Components/Banner',
} satisfies Meta<React.ComponentProps<typeof Banner>>;

export default componentMeta;
type Story = StoryObj<typeof componentMeta>;

export const Variants: Story = {
  // @ts-expect-error We don't want to pass any args to this story
  args: {},
  parameters: {
    docs: {
      source: {
        code: BannerVariantsSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: BannerVariants,
};

export const WithIcons: Story = {
  // @ts-expect-error We don't want to pass any args to this story
  args: {},
  parameters: {
    docs: {
      source: {
        code: BannerWithIconsSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: BannerWithIcons,
};

export const Closeable: Story = {
  // @ts-expect-error We don't want to pass any args to this story
  args: {},
  parameters: {
    docs: {
      source: {
        code: BannerCloseableSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: BannerCloseable,
};

export const Global: Story = {
  // @ts-expect-error We don't want to pass any args to this story
  args: {},
  parameters: {
    docs: {
      source: {
        code: BannerGlobalSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: BannerGlobal,
};

export const WithActions: Story = {
  // @ts-expect-error We don't want to pass any args to this story
  args: {},
  parameters: {
    docs: {
      source: {
        code: BannerWithActionsSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: BannerWithActions,
};

export const WithoutTitle: Story = {
  // @ts-expect-error We don't want to pass any args to this story
  args: {},
  parameters: {
    docs: {
      source: {
        code: BannerWithoutTitleSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: BannerWithoutTitle,
};
